import { ref } from 'vue'
import { fetchShoppingDestinationDataApi } from '@/assets/ts/apiManagement'

export interface ShoppingDestinationItem {
	title: string
	img: string
	url?: string
	alt?: string
}

export function useFetchShoppingData() {
	const shoppingDestinationData = ref<ShoppingDestinationItem[]>([])

	async function fetchShoppingDestinationData() {
		shoppingDestinationData.value = await fetchShoppingDestinationDataApi()
	}

	return {
		shoppingDestinationData,
		fetchShoppingDestinationData,
	}
}
